(function () {
    'use strict';

    angular.module('l4b')
        .filter('prop', function () {
            return function (x, prop) {
                return x ? x[prop] : '';
            };
        });
})();